import Api from './Api';
import store from '../store.js';
import lodash from 'lodash';
import ProductService from './ProductService'


function getBaseURL()
{
    return process.env.CUSTOMER_PROFILE_API_ENDPOINT;
}

export default {
    StartCheckoutProcess(vue) {
debugger
        if(!store.state.auth.userInfo) {
            vue.$toasted.error('You must be logged in to Checkout').goAway(3000);
            return;
        }

        if(!store.state.checkout.checkoutStarted) {
            store.state.checkout.checkoutStarted = true;

            var company = _.find(store.state.auth.userInfo.Companies, i => i.Oid === store.state.auth.company.Oid);

            store.state.checkout.company = company;
            var shippingAddress = company.Addresses.find(el => el.Oid === company.PrimaryShippingAddress.Oid);
            
            //var shippingAddress = store.state.auth.userInfo.Addresses.find(el => el.Oid === store.state.auth.userInfo.Company.PrimaryShippingAddress.Oid);
            // var shippingAddress = lodash.find(store.state.auth.userInfo.Addresses, function(a) { return a.IsPrimaryShipping; } );

            if (!shippingAddress && company.Addresses.length > 0) {
                shippingAddress = company.Addresses.Addresses[0];
            }

            store.state.checkout.shippingAddress = Object.assign({}, shippingAddress);
            store.state.checkout.po = `${store.state.auth.userInfo.FirstName} ${store.state.auth.userInfo.LastName}`;
        }
        
        vue.$router.push({name: 'Checkout'});
    },
    SubmitOrder(success, fail) {

        var payload = {
            // BillingAddress: store.state.checkout.billingAddress,
            CompanyOid: store.state.checkout.company.Oid,
            ShippingAddress: store.state.checkout.shippingAddress,
            Comments: store.state.checkout.comments,
            Po: store.state.checkout.po,
            Items: lodash.sortBy(store.state.cart, 'SortPriority'),
            PromoCode: store.state.checkout.code,
        }

        debugger;
        //ensure items quantity fields are actually a number - if not a number set to 0
        payload.Items.forEach(i => {
            i.Qty = Number(i.Qty) || 0;
            i.CartonQuantity = Number(i.CartonQuantity) || 0;
            i.FullBoxQty = Number(i.FullBoxQty) || 0;
        });

        var endpoint = process.env.CHECKOUT_WORKFLOW_ENDPOINT;

        Api.post(process.env.CHECKOUT_WORKFLOW_ENDPOINT, payload)
            .then((response) => {
                if(response.data.Data.Error) {
                    fail(response.data.Data);
                }
                else{
                    success(response.data.Data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    UpdateCartPrices() {
debugger
        var promiseList = [];

        var toBeRemoved = [];
        
        lodash.forEach(store.state.cart, line => {
            var promise = ProductService.GetByItemNumber(line).then(result => {
                if(result.data.length > 0) {
                    line.Price = result.data[0].Price;
                    line.Type = result.data[0].Type;
                    line.Oid = result.data[0].Oid;
                    line.ProductOid = result.data[0].ProductOid;
                }
                else
                {
                    toBeRemoved.push(line);
                }
            });
            promiseList.push(promise);
        });

        var result = Promise.all(promiseList).then(() => {
            lodash.remove(toBeRemoved, (product) => {
                store.commit("RemoveFromCart", product);
            });
        });

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/services/CheckoutService.js